<template>
  <div style="width: 100%">
    <el-container>
      <el-header style="height: 60px">
        <el-menu
          router
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <div class="s-logo" @click="index">
            <img class="logo" :src="conf.web_site_logo" alt />
          </div>
          <el-menu-item
            :index="item.t_url"
            v-for="item in pageData.top_list"
            :key="item?.id"
            >{{ item.t_name }}</el-menu-item
          >

          <div class="s-logo1">
            <div class="shuru">
              <span class="el-icon-search" @click="handleSubmit"></span>
              <input
                type="text"
                @keyup.enter="handleSubmit"
                v-model.trim="search"
              />
            </div>
            <span
              style="
                white-space: nowrap;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 600;
                color: #333333;
              "
              >更多...</span
            >
          </div>
          <div
            style="
              display: flex;
              height: 100%;
              align-items: center;
              margin-left: 25px;
              cursor: pointer;
              position: relative;
            "
            @click="isPick = !isPick"
          >
            <svg
              t="1751009488801"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1567"
              width="20"
              height="20"
            >
              <path
                d="M757.205333 473.173333c5.333333 0 10.453333 2.090667 14.250667 5.717334a19.029333 19.029333 0 0 1 5.888 13.738666v58.154667h141.184c11.093333 0 20.138667 8.704 20.138667 19.413333v232.704a19.797333 19.797333 0 0 1-20.138667 19.413334h-141.184v96.981333a19.754667 19.754667 0 0 1-20.138667 19.370667H716.8a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.888-13.696v-96.981333h-141.141333a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.930666-13.738667v-232.704c0-5.12 2.133333-10.112 5.930666-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h141.141333v-58.154667c0-5.162667 2.133333-10.112 5.888-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h40.362667zM192.597333 628.394667c22.272 0 40.32 17.365333 40.32 38.826666v38.741334c0 40.618667 32.512 74.368 74.624 77.397333l6.058667 0.213333h80.64c21.930667 0.469333 39.424 17.706667 39.424 38.784 0 21.077333-17.493333 38.314667-39.424 38.784H313.6c-89.088 0-161.28-69.461333-161.28-155.178666v-38.741334c0-21.461333 18.005333-38.826667 40.277333-38.826666z m504.106667 0h-80.64v116.394666h80.64v-116.394666z m161.28 0h-80.64v116.394666h80.64v-116.394666zM320.170667 85.333333c8.234667 0 15.658667 4.778667 18.773333 12.202667H338.773333l161.322667 387.84c2.517333 5.973333 1.706667 12.8-2.005333 18.090667a20.394667 20.394667 0 0 1-16.725334 8.533333h-43.52a20.181333 20.181333 0 0 1-18.688-12.202667L375.850667 395.648H210.901333l-43.264 104.149333A20.181333 20.181333 0 0 1 148.906667 512H105.514667a20.394667 20.394667 0 0 1-16.725334-8.533333 18.773333 18.773333 0 0 1-2.005333-18.090667l161.28-387.84A20.181333 20.181333 0 0 1 266.88 85.333333h53.290667zM716.8 162.901333c42.794667 0 83.84 16.341333 114.090667 45.44a152.234667 152.234667 0 0 1 47.232 109.738667v38.741333c-0.469333 21.077333-18.389333 37.930667-40.32 37.930667s-39.808-16.853333-40.32-37.930667v-38.741333c0-20.608-8.490667-40.32-23.637334-54.869333a82.304 82.304 0 0 0-57.045333-22.741334h-80.64c-21.888-0.469333-39.424-17.706667-39.424-38.784 0-21.077333 17.493333-38.314667 39.424-38.784h80.64z m-423.424 34.304L243.2 318.037333h100.48L293.418667 197.205333z"
                fill="#234ce2"
                p-id="1568"
              ></path>
            </svg>
            <div class="pick-en" v-if="isPick">
              <div class="en-item" @click="switchLang('chinese_simplified')">
                中文
              </div>
              <div class="en-item" @click="switchLang('english')">English</div>
            </div>
          </div>
        </el-menu>
      </el-header>

      <el-main>
        <!-- 二级路由入口 -->
        <router-view />
      </el-main>

      <div class="footer">
        <div class="t_box">
          <div class="tlt">
            <div
              class="yitiao"
              v-for="item in pageData.bottom_list"
              :key="item.id"
            >
              <div class="big_s" @click="bigbtn(item)">{{ item.t_name }}</div>
              <div
                class="sml_s"
                v-for="itemSon in item.child.slice(0, 7)"
                :key="itemSon.id"
                @click="smlbtn(item, itemSon)"
              >
                {{ itemSon.t_name }}
              </div>
            </div>
          </div>
          <div>
            <div
              class="logo"
              style="width: 120px; height: 25px; margin-bottom: 10px"
            >
              <img
                style="width: 120px; height: 25px"
                :src="conf.web_site_logo"
                alt
              />
            </div>
            <div class="t_pic">
              <img :src="conf.web_company_qrcode" alt />
            </div>
            <div class="txt">扫一扫了解更多</div>
          </div>
        </div>
        <div class="icp">{{ conf.web_site_icp }}</div>
      </div>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import translate from "i18n-jsautotranslate";
// import store from '@/store/index.js'
import router from "@/router";
export default {
  data() {
    return {
      conf: "",
      activeIndex: "0",
      pageData: {},
      search: "",
      isPick: false,
      translate,
    };
  },
  methods: {
    handleSubmit() {
      // 搜索框提交
      if (this.search === "") return; // 空内容拦截
      if (this.$route.path === "/goodDetail") {
        // 如果是详情页跳转首页在回调
        router.push("/");
      }
      console.log(encodeURIComponent(this.search));
      router.push("/goodDetail?keyword=" + this.search);
      this.search = ""; // 搜索后清空
    },
    handleSelect(key, keyPath) {
      key === keyPath;
    },
    getPageData() {
      // 获取页面数据
      axios({
        url: this.base_url.base_url + "/index.php/index/index/navigation_list",
        method: "get",
      })
        .then((res) => {
          this.pageData = res.data.data;
          // 处理底部url
          this.pageData.top_list.forEach((v, i) => {
            this.pageData.bottom_list[i].t_url = v.t_url;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    get_conf() {
      // 获取页面配置信息
      axios({
        url: this.base_url.base_url + "/index.php/index/index/web_conf",
        method: "get",
      })
        .then((res) => {
          const { data } = res;
          this.conf = data.data; // 获取页面配置信息
          document.title = this.conf.web_name; // 获取页面标题
          if (sessionStorage.getItem("language")) return;
          if (this.conf.language == "zh-cn") {
            this.switchLang("chinese_simplified");
          } else {
            this.switchLang("english");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    bigbtn(item) {
      // 底部一级标题点击
      if (this.$route.path === item.t_url) return;
      this.$router.push(item.t_url);
    },
    smlbtn(item, itemSon) {
      // 底部二级标题点击
      if (item.id) {
        if (this.$route.path === item.t_url) {
          this.$router.push("/");
        }
        this.$nextTick(() => {
          this.$router.push(item.t_url + "?id=" + itemSon.id);
        });
      }
    },
    pushSecPage() {
      this.pageData.top_list.forEach;
    },
    index() {
      if (this.$route.path === "/page/index") return;
      router.push("/page/index");
    },
    switchLang(lang) {
      sessionStorage.setItem("language", lang);
      this.translate.language.clearCacheLanguage();
      this.translate.language.setDefaultTo(lang);
      this.translate.listener.start();
      this.translate.whole.enableAll(); //整体翻译
      this.translate.execute();
      location.reload("?l=true");
    },
  },
  created() {
    this.get_conf();
    this.getPageData();
  },
  mounted() {
    this.translate.execute();
  },
};
</script>

<style scoped lang="scss">
.el-header {
  padding: 0;
}
.el-menu-demo {
  display: flex;
  width: 1323px;
  margin: 0 auto;
}

.s-logo {
  margin-right: 195px;
  cursor: pointer;

  .logo {
    width: 180px;
    height: 23px;
    margin-top: 22px;
  }
}

.s-logo1 {
  height: 60px;
  display: flex;
  align-items: center;

  .shuru {
    width: 137px;
    height: 26px;
    background: #234ce2;
    border-radius: 13px 13px 13px 13px;
    position: relative;
    margin-left: 45px;
    margin-right: 60px;

    span {
      position: absolute;
      left: 6px;
      top: 20%;
      color: white;
    }

    input {
      background: #234ce2;
      width: 98px;
      position: absolute;
      right: 10px;
      top: 16%;
      /* transform: scaleY(50%); */
      color: #ffffff;
      outline: none;
    }
  }
}

.el-main {
  padding: 0;
  /* transform: scale(0.7); */
}

.el-menu.el-menu--horizontal {
  border: 0;
  height: 60px;

  .el-menu-item {
    width: 130px;
    height: 60px;
    text-align: center;
    font-size: 16px;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    color: #333333;

    &.is-active {
      border: 0;
      background: #234ce2;
      color: white;
    }
  }
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: #234ce2;
  color: white;
}

.el-menu-item {
  color: #303133;
  transition: none;
  box-sizing: border-box;
  white-space: nowrap;
  transition-duration: 0s;
}

.footer {
  width: 100%;
  background: #f4f8fb;

  .t_box {
    width: 100%;
    padding: 50px 0 0 0;
    display: flex;
    justify-content: space-evenly;

    .tlt {
      width: 820px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 70px;

      .yitiao {
        width: 100px;
        text-align: center;

        .big_s {
          font-size: 24px;
          margin-bottom: 20px;
          color: #333333;
          font-size: 18px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 700;
          cursor: pointer;
        }

        .sml_s {
          margin-bottom: 10px;
          cursor: pointer;
        }
      }
    }

    .t_pic {
      // float: right;
      img {
        width: 121px;
        height: 119px;
      }
    }
  }

  .icp {
    width: 100%;
    background-color: #234ce2;
    color: #fff;
    text-align: center;
    line-height: 30px;
    height: 30px;
  }
}
.pick-en {
  position: absolute;
  left: 50%;
  bottom: 0;
  z-index: 999999 !important;
  transform: translate(-50%, 100%);
  padding: 10px 12px;
  background-color: #fff;
  .en-item {
    width: 100px;
    line-height: 30px;
    text-align: center;
    border-radius: 10px;
    &:hover {
      color: #234ce2;
      background-color: #eee;
    }
  }
}
</style>
